import { combineReducers } from 'redux';

import {
  setOpenNameScriptInstructionModal,
  setNameScriptInstructionId,
  setInlineNameScriptInstruction,
} from '../actions';
import { ScriptEditorAction, NameScriptInstructionState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof NameScriptInstructionState> = Reducer<NameScriptInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenNameScriptInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setNameScriptInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};

const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineNameScriptInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
});
